import React from "react";
import { Link } from "react-router-dom";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Stack, Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

const crumbTextSx = {
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "16px",
  color: "#496682",
  cursor: "pointer",
  "&:hover": { color: "#071f35" },
  textDecoration: "none",
  maxWidth: 160
};

const currentCrumbTextSx = {
  ...crumbTextSx,
  color: "#071f35",
  fontWeight: 500,
  cursor: "default",
  "&:hover": { color: "#071f35" }
};

const crumbWithEllipsisSx = {
  ...crumbTextSx
};

interface Props {
  links: { path: string; title: string }[];
}

export const Breadcrumbs: React.FC<Props> = ({ links }) => {
  return (
    <Stack direction="row" alignItems="center" sx={{ minWidth: 0, overflow: "hidden" }}>
      {links.map((link, index) => {
        const isLast = index === links.length - 1;
        const textSx = isLast ? currentCrumbTextSx : crumbWithEllipsisSx;

        return (
          <Stack
            key={link.path}
            direction="row"
            alignItems="center"
            sx={index === 0 ? { flexShrink: 0 } : { minWidth: 0 }}
          >
            {isLast ? (
              <Typography noWrap sx={textSx}>
                {link.title}
              </Typography>
            ) : (
              <MaterialTooltip isShow title={link.title} placement="top">
                <Link to={link.path} style={{ textDecoration: "none" }}>
                  <Typography noWrap sx={textSx}>
                    {link.title}
                  </Typography>
                </Link>
              </MaterialTooltip>
            )}
            {!isLast && <ChevronRightIcon sx={{ fontSize: 24, color: "#496682", flexShrink: 0 }} />}
          </Stack>
        );
      })}
    </Stack>
  );
};
